'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PageBase = require('./core/PageBase');

var _PageBase2 = _interopRequireDefault(_PageBase);

var _PageLayout = require('./core/PageLayout');

var _PageLayout2 = _interopRequireDefault(_PageLayout);

var _PageRouter = require('./pages/PageRouter');

var _PageRouter2 = _interopRequireDefault(_PageRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Page = {
  PageBase: _PageBase2.default,
  PageLayout: _PageLayout2.default,
  PageRouter: _PageRouter2.default
};

exports.default = Page;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_rs-page@0.0.3@rs-page/lib/index.js
// module id = 1914
// module chunks = 0